import { Result } from "antd";
import { useEffect } from "react";
import bodgan from "../../assets/images/alexandru-bogdan-ghita-mM3gkzh6yn0-unsplash.jpg";
import PageBanner from "../../components/PageBanner";
import PageBreadcrumb from "../../components/PageBreadcrumb";
import PageLayout from "../../components/PageLayout";
import StandardPageBlock from "../../components/StandardPageBlock";
import { setPageTitle } from "../../utils";
import { ROUTES } from "../../utils/enums";
import "./styles.less";

const breadcrumbs = [
  { link: ROUTES.PROJECTS_ON_GOING, value: "Projets en cours" },
  { value: "Pas de projet" },
];

const ProjectOnGoing = () => {
  useEffect(() => {
    setPageTitle("Pas de projet en cours");
  }, []);

  return (
    <PageLayout>
      <>
        <PageBanner
          image={{
            src: bodgan,
            alt: "Production de gaz naturel à Ntolo",
            id: "ntolo",
          }}
          title="Pas de projet"
        />
        <PageBreadcrumb items={breadcrumbs} />
        <StandardPageBlock>
          <Result status={404} title="Pas de projet en cours" />
        </StandardPageBlock>
      </>
    </PageLayout>
  );
};

export default ProjectOnGoing;
